class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    this.bindCheckoutIntent();
  }

  bindCheckoutIntent() {
    this.addEventListener('pointerenter', (event) => {
      if (event.target.closest('[name="checkout"]')) this.prefetchCheckout();
    }, true);

    this.addEventListener('focusin', (event) => {
      if (event.target.closest('[name="checkout"]')) this.prefetchCheckout();
    });

    this.addEventListener('click', (event) => {
      const checkoutButton = event.target.closest('[name="checkout"]');
      if (!checkoutButton || checkoutButton.disabled) return;

      checkoutButton.classList.add('loading');
      checkoutButton.setAttribute('aria-disabled', 'true');
    });
  }

  prefetchCheckout() {
    if (document.querySelector('link[data-ushore-checkout-prefetch]')) return;

    const link = document.createElement('link');
    link.rel = 'prefetch';
    link.href = '/checkout';
    link.as = 'document';
    link.dataset.ushoreCheckoutPrefetch = 'true';
    document.head.appendChild(link);
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;
    if (cartLink.dataset.cartDrawerBound === 'true') return;
    cartLink.dataset.cartDrawerBound = 'true';

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      document.querySelectorAll('ushore-search-drawer.active, ushore-wishlist-drawer.active, ushore-menu-drawer.active').forEach((drawer) => {
        if (window.ushoreCloseDrawerWithMotion) {
          window.ushoreCloseDrawerWithMotion(drawer);
        } else {
          drawer.classList.remove('active');
          drawer.setAttribute('aria-hidden', 'true');
        }
      });
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (this.classList.contains('active')) return;
    window.ushoreCloseUtilityDrawers?.(this);
    this.prefetchCheckout();
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    this.classList.remove('ushore-drawer-closing');
    this.classList.add('animate');
    window.requestAnimationFrame(() => {
      this.classList.add('animate', 'active');
    });

    const drawerPanel = this.querySelector('.drawer__inner');
    const focusDrawer = () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty')
        ? this.querySelector('.drawer__inner-empty')
        : document.getElementById('CartDrawer');
      const focusElement = drawerPanel || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    };
    window.setTimeout(focusDrawer, 80);

    window.ushoreLockPage?.();
  }

  close() {
    if (!window.ushoreCloseDrawerWithMotion) {
      this.classList.remove('active');
      removeTrapFocus(this.activeElement);
      window.ushoreUnlockPage?.();
      return;
    }
    window.ushoreCloseDrawerWithMotion(this, () => {
      removeTrapFocus(this.activeElement);
      window.ushoreUnlockPage?.();
    });
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
